export default "__VITE_ASSET__Dy3Axgfv__"